import React from "react";
import { useProcedureAssignmentSettingRuleSet } from "./hooks";
import ProcedureAssignmentSettingRuleSetListPresenter from "./index";
import { useFeatureFlag_EnableAssignmentSettingRuleset } from "../../../../../feature-flags";
import { Redirect } from "react-router-dom";
import { SmartApplyR } from "../../route";

const ProcedureAssignmentSettingRuleSetListContainer: React.FC = () => {
  const { isLoading, assignmentSettingRuleSets, paging, movePage } =
    useProcedureAssignmentSettingRuleSet();

  if (!useFeatureFlag_EnableAssignmentSettingRuleset()) {
    return <Redirect to={SmartApplyR.Applications.link({})} />;
  }

  return (
    <ProcedureAssignmentSettingRuleSetListPresenter
      ruleSets={assignmentSettingRuleSets}
      isLoading={isLoading}
      paging={paging}
      movePage={movePage}
    />
  );
};

export default ProcedureAssignmentSettingRuleSetListContainer;
